'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var List = require('./list')

var ClientsNodesModule = function () {

  //
  var API = {
    listNodes: function (options) {
      var nodesList = new List(options)
      nodesList.listNodes()
    }
  }

  App.globalChannel.on('client-nodes:list', function (options) {
    API.listNodes(options)
  })


}

module.exports = ClientsNodesModule



// WEBPACK FOOTER //
// ./js/modules/client-nodes/index.js